import { CONTACT_TYPES_ENDPOINT, getContactTypes } from '@src/service/contact-type'
import useSWR from 'swr'

export const useContactTypes = () => {
  return useSWR(CONTACT_TYPES_ENDPOINT, getContactTypes)
}
